module.exports = __webpack_public_path__ + "static/img/sign.255576c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/sign.png
// module id = MQvJ
// module chunks = 1